/**
 * Labstep
 *
 * @module components/ProtocolValue/Form/ShowEdit/AmountUnit
 * @desc ProtocolValue Amount Unit
 */

import { ProtocolValueFormShowEditAmount } from 'labstep-web/components/ProtocolValue/Form/ShowEdit/Amount';
import { ProtocolValueFormShowEditUnit } from 'labstep-web/components/ProtocolValue/Form/ShowEdit/Unit';
import { Flex } from 'labstep-web/core/Flex';
import type React from 'react';
import styles from './styles.module.scss';
import type { IProtocolValueFormShowEditAmountUnitProps } from './types';

export const ProtocolValueFormShowEditAmountUnit: React.FC<
  IProtocolValueFormShowEditAmountUnitProps
> = ({ protocolValue, placeholder }) => (
  <Flex className={styles.container}>
    <ProtocolValueFormShowEditAmount
      protocolValue={protocolValue}
      placeholder={placeholder}
    />
    <ProtocolValueFormShowEditUnit
      protocolValue={protocolValue}
      placeholder={placeholder}
    />
  </Flex>
);
